import React from "react";
import PropTypes from 'prop-types';
import { Icon, Typography } from '../../index';

const CheckboxSelect = (props) => {
    const { isChecked, label, disabled, handleCheck } = props;

    const handleOnClick = () => {
        if (!disabled) {
            handleCheck();
        }
    }

    const labelClasses = `checkbox-select-wrapper ${isChecked ? "checkbox-select--selected" : ""} ${disabled ? "checkbox-select--disabled" : ""}`

    return (
        <label className={labelClasses}>
            <div className={`checkboxselect-container`}>
                <div className="checkbox-select__checkbox">
                    <input type="checkbox"
                        defaultChecked={isChecked}
                        disabled={disabled}
                        onChange={handleOnClick}
                    />
                    <span className={`checkmark`} />
                    {isChecked && <Icon name="check" color="$color-primary-c1" />}
                </div>
                <div className="label">
                    <Typography type="body-02">{label}</Typography>
                </div>
            </div>
        </label>
    );
}

CheckboxSelect.defaultProps = {
    disabled: false
}

CheckboxSelect.propTypes = {
    disabled: PropTypes.bool,
}
export default CheckboxSelect;